export enum PLAYLIST_LOCATION {
  B2C_PRODUCT_PAGE = 'bundle-product_page',
}

export interface TPlaylistReconciliationData {
  playlistFingerprint: string;
  playlistReconciliation: string;
}
